let header = document.querySelector(".header")
let headerBtn = document.querySelector(".header__fixedBtnsBtn.menu")
let body = document.body

headerBtn.addEventListener("click", () => {
    header.classList.toggle("is-on");
    noscroll(header.classList.contains("is-on"))
})

function noscroll(bool) {
    if (bool) {
        body.style.overflow = "hidden"
    } else {
        body.style.overflow = ""
    }
}